Z<template>
<div class="dashboard">
  <template v-if="!unusualFlag">
    <template v-if="isCustomer">
      <div class="person-nav-outer">
          <audit-reject-reason></audit-reject-reason>
      </div>
      <h3 class="page-title">{{helloText}},{{name}}</h3>
      <home-carousel></home-carousel>
      <!--客户和代理首页是一样的 已分开 -->
      <div
        v-if="!tradeDone"
        class="trading-journey">
        <!--    完成所有流程后整个交易旅程不显示 -->
        <!--      /*custStatus
              1, "注册未申请",
              2, "已申请未开户",
              3, "开户未入金",
              4, "入金未交易",
              5, "已交易",
              6, "销户",
              10, "注册未激活";*/

              /*  auditStatus:
              1, "客服审核",
              2, "交易部审核",
              3, "审核拒绝",
              4, "审核通过",
              5, "冻结",
              6, "销户",
              7, "账户信息复审";*/-->
        <h3 class="card-title">{{$t('Start_your_trading_journey')}}</h3>
        <el-row
          :gutter="10"
        >
          <el-col
            :lg="6"
            :md="12"
            :sm="12"
            :xs="24"
          >
            <div
              @click="infoAuthJumpHandle"
              class="trading-step"
              :class="{on: !infoAuthFlag }"
            >
              <div class="step-top">
                <h4 class="step-title">{{$t('User.reportImgStatus')}}</h4>
                <!--              需要点击跳转,  -->
                <i
                  class="el-icon-right pointer"></i>
              </div>
              <div class="step-bot">
            <span
              v-if="infoAuthFlag"
              class="done">
              <i
                class="el-icon-success right-icon"></i>
              {{$t('withgold.statusComple')}}
            </span>
                <span
                  v-if="!infoAuthFlag"
                  class="no-done">
              <i class="el-icon-error"></i>
              {{$t('undone')}}
            </span>
              </div>
            </div>
          </el-col>
          <el-col
            :lg="6"
            :md="12"
            :sm="12"
            :xs="24"
          >
            <div
              @click="openAccountHandle"
              class="trading-step"
              :class="{on: !openAccountDone }"
            >
              <div class="step-top">
                <h4 class="step-title">{{$t('User.openAcc')}}</h4>
                <i
                  class="el-icon-right pointer"></i>
              </div>
              <div class="step-bot">
              <span
                v-if="openAccountDone"
                class="done">
                <i class="el-icon-success right-icon"></i>
                {{$t('withgold.statusComple')}}
              </span>
                <span
                  v-if="!openAccountDone"
                  class="no-done">
                <i class="el-icon-error"></i>
                {{$t('undone')}}
              </span>
              </div>
            </div>
          </el-col>
          <el-col
            :lg="6"
            :md="12"
            :sm="12"
            :xs="24"
          >
            <div
              @click="depositHandle"
              class="trading-step"
              :class="{on: !depositDone }"
            >
              <div class="step-top">
                <h4 class="step-title">{{$t('Trade.deposit')}}</h4>
                <i
                  class="el-icon-right pointer"></i>
              </div>
              <div class="step-bot">
                <span
                  v-if="depositDone"
                  class="done"
                >
                  <i class="el-icon-success right-icon"></i>
                  {{$t('withgold.statusComple')}}
                </span>
                <span
                      v-if="!depositDone"
                      class="no-done">
                  <i class="el-icon-error"></i>
                  {{$t('undone')}}
                </span>
              </div>
            </div>
          </el-col>
          <el-col
            :lg="6"
            :md="12"
            :sm="12"
            :xs="24"
          >
            <div
              @click="tradeHandle"
              class="trading-step"
              :class="{on: !tradeDone }"
            >
              <div class="step-top">
                <h4 class="step-title">{{$t('trade')}}</h4>
                <i class="el-icon-right pointer"></i>
              </div>
              <div class="step-bot">
            <span
              v-if="tradeDone"
              class="done"
            >
              <i class="el-icon-success right-icon"></i>
              {{$t('withgold.statusComple')}}
            </span>
                <span
                  v-if="!tradeDone"
                  class="no-done"
                >
              <i class="el-icon-error"></i>
              {{$t('undone')}}
            </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <account-list
        ref="accountlist"
        :can-open-account-count="canOpenAccountCount"
      ></account-list>
    </template>
    <template v-else>
      <propagandas-page></propagandas-page>
    </template>
  </template>
  <template v-else>
    <no-pass-audit
      :user-status="userStatus"
    ></no-pass-audit>
  </template>
  <notice-dialog ref="notice"></notice-dialog>
</div>
</template>

<script>
import { queryNoticeDialog } from '@/api/user'
import noticeDialog from '@/components/common/noticeDialog'
import propagandasPage from '@/views/agent/propagandas/index';
import { GetCustInFo } from '@/api/userCenter.js';
import noPassAudit from "@/components/dashboard/noPassAudit";
import accountList from "@/components/dashboard/accountList";
import homeCarousel from '@/components/dashboard/homeCarousel';
import twoOneModule from '@/components/dashboard/twoOneModule';
import auditRejectReason from '@/components/common/auditRejectReason'
import { mapGetters } from 'vuex';
export default {
  name: "index",
  components: {
    twoOneModule,
    homeCarousel,
    accountList,
    noPassAudit,
    propagandasPage,
    noticeDialog,
    auditRejectReason
  },
  data() {
    return {
      config: {
        banerType: 1,
      },
      canOpenAccountCount: 0,
      isMobile: true,

      custInfo: {

      }
    }
  },
  watch: {
    listRefresh(newValue, oldValue) {
      this.matchAndHandleDialog();
    }
  },
  computed: {
  ...mapGetters(['language','userInfo','realMobile','listRefresh','agentRole']),
    isCustomer(){
      return this.userInfo.custType == 3 || (this.userInfo.custType == 1 && this.agentRole == 'CUSTOMER');
    },
    infoAuthFlag(){
      if(this.custInfo.custStatus >= 2 && this.custInfo.custStatus <= 5){
        return true;
      }else {
        return false;
      }
    },
    openAccountDone(){
      if(this.custInfo.custStatus >= 3 && this.custInfo.custStatus <= 5){
        return true;
      }else {
        return false;
      }
    },
    depositDone(){
      if(this.custInfo.custStatus >= 4 && this.custInfo.custStatus <= 5){
        return true;
      }else {
        return false;
      }
    },
    tradeDone(){
      if(this.custInfo.custStatus == 5){
        return true;
      }else {
        return false;
      }
    },
    unusualFlag(){
      //未通过审核
      return this.userInfo.custStatus ==  10 || this.userInfo.custStatus == 1 || (this.userInfo.auditStatus ==  1 || this.userInfo.auditStatus == 2) || this.userInfo.auditStatus ==  3;
    },
    userStatus(){
      let auditStatus = this.userInfo.auditStatus || 1;
      let custStatus = this.userInfo.custStatus;
      //参考旧项目代码
      if(custStatus== 10) {
        return 3;
      }else if(custStatus == 1){
        return 4;
      }else {

        if(auditStatus == 1 || auditStatus == 2){
          return 1;
        }else{
          return 2;
        }
      }
    },
    helloText() {
      let hoursNumber = this.nowTime.getHours();
      if(0 < hoursNumber && hoursNumber < 12){
        return this.$t('good_morning');
      }else if(hoursNumber > 12 && hoursNumber < 18 ) {
        return this.$t('Good_afternoon');
      }else {
        return this.$t('Good_evening');
      }
    },
    nowTime(){
      return new Date();
    },
    name(){
      return this.userInfo.firstName + this.userInfo.lastName;
    },
  },
  created(){
    this.getUserStatus();
    /*custStatus
  1, "注册未申请",
  2, "已申请未开户",
  3, "开户未入金",
  4, "入金未交易",
  5, "已交易",
  6, "销户",
  10, "注册未激活";*/

    /*  auditStatus:
    1, "客服审核",
    2, "交易部审核",
    3, "审核拒绝",
    4, "审核通过",
    5, "冻结",
    6, "销户",
    7, "账户信息复审";*/

    //分两种情况,1是客户面板,读过之后刷新就不显示,如果客户切换未代理就还需要显示,
    this.matchAndHandleDialog();
  },
  methods: {
    getUserStatus(){
      GetCustInFo({custId: this.userInfo.id}).then((res) => {
        this.custInfo = res.data;
        //auditStatus, custStatus
        //更新localStarage和vuex的userInfo数据
        let selfUserInfo = JSON.parse(localStorage.getItem('userInfo'));
        selfUserInfo.auditStatus = this.custInfo.auditStatus;
        selfUserInfo.custStatus = this.custInfo.custStatus;
        let selfVuexUserInfo = JSON.parse(JSON.stringify(this.userInfo));
        selfVuexUserInfo.auditStatus = this.custInfo.auditStatus;
        selfVuexUserInfo.custStatus = this.custInfo.custStatus;
        localStorage.setItem('userInfo',JSON.stringify(selfUserInfo));
        this.$store.commit('setUserInfo', selfVuexUserInfo);
      })
    },
    matchAndHandleDialog(){
      if(this.isCustomer){
        if(!localStorage.getItem('isReadedCustomerInfo')){
          this.getDialogInfo(() => {
            localStorage.setItem('isReadedCustomerInfo','done');
          });
        }
      }else {
        if(!localStorage.getItem('isReadedAgentInfo')){
          this.getDialogInfo(() => {
            localStorage.setItem('isReadedAgentInfo','done')
          });
        }
      }
    },
    // 查询弹框信息
    getDialogInfo(callback){
      // 公告通知
      queryNoticeDialog({custId: this.userInfo.id,receiverType: this.isCustomer ? 1: 2}).then((res)=> {

        this.$store.commit('setNoticeDialogShow',Boolean(res.data.content.length));
        if(res.data.content.length){
          this.$store.commit('setNoticeDialogInfo',res.data.content[0]);

          callback();
        }
      });
    },
    // 跳转
    infoAuthJumpHandle(){
      // if(this.infoAuthFlag) return;
      this.$router.push({name: 'personalInformation'});
    },
    openAccountHandle(){
      // if(this.openAccountDone) return;
      this.$store.commit('setOpenAccountDialogShow', true);
    },
    depositHandle(){
      // if(this.depositDone) return;
      this.$router.push({name: 'depositFunds'});
    },
    tradeHandle(){
      if(this.tradeDone) return;
      this.$router.push({name: 'download'});
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard {
  .person-nav-outer{
    margin-bottom: 10px;
  }
  .page-title {
    color: #5E5873;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .trading-journey {
    margin-top: 25px;
    .card-title {
      color: #5E5873;
      font-size: 16px;
      font-weight: 600;
    }
  }
  .trading-step {
    background-color: #ffffff;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 10px;
    &.on {
      cursor: pointer;
    }
    .step-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .el-icon-right {
        font-size: 14px;
        cursor: pointer;
      }
    }
    .right-icon {
      color: #41B883;
    }
    .el-icon-error {
      color: #B9B9C3;
    }
  }
  .wallet {
    margin-top: 20px;
    .wallet-card {
      background-color: #ffffff;
      padding: 20px;
      .card-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 14px;
        .card-top-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .icon-box {
          width: 30px;
          height: 30px;
          margin-right: 10px;
          background-color: rgba(255, 159, 67, 0.12);
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .account-img {
            width: 18px;
            height: 16px;
          }
        }
      }
      .wallet-data {
        .money {
          font-size: 24px;
          font-weight: bold;
        }
        .symbol {
          font-size: 14px;
          padding-left: 10px;
          color: #B9B9C3;
        }
      }
    }
  }
  .card-title {
    margin-bottom: 15px;
  }
  .step-title {
    font-size: 16px;
  }
  .step-bot {
    i {
      font-size: 16px;
    }
  }
}
</style>
